<template>
  <div id="app">
    <div class="top"
         style="z-index:1000;"
         v-if="$route.path !== '/sery' && !$store.state.kakao">
      <div class="top-inner">
        <div class="back-button"
             @click="handleBackPage">
          <img src="@/assets/btn_back_arrow.png"
               class="back-button-img"
               alt="">
        </div>
        <img v-if="!$empty(appIcon)"
             :src="appIcon"
             class="top-logo"
             style="height: 45px;"
             @click="$route.path === '/storeMain' ? $router.go($router.currentPage) : moveRouter('storeMain')">
        <img v-else
             src="@/assets/logo/tery.svg"
             class="top-logo"
             @click="$route.path === '/storeMain' ? $router.go($router.currentPage) : moveRouter('storeMain')">
        <!-- <img src="@/assets/btn_kakao_login.png" class="login-img" @click="loginWithKakao1" alt=""> -->
        <!-- <img src="@/assets/btn_kakao_login.png" class="login-img" v-if="$empty($cookies.get('kakaoLogin'))" @click="loginWithKakao1"> -->
        <!-- <img src="@/assets/icon/btn_download.svg" class="login-download-img" @click="moveToApp"> -->
        <div v-if="appFlag === '1'"
             class="tery-app login-download-img"
             @click="moveToApp">
          앱 할인가 받기
        </div>
        <div v-else
             class="tery-app login-download-img"
             @click="moveToApp">
          더 편리한 주문
        </div>
        <!-- <span class="login-id" v-if="!$empty($cookies.get('kakaoLogin'))">
          {{$cookies.get('kakaoLogin').id}}님
        </span>
        <img src="@/assets/icon/login_icon.png" class="logout-img" v-if="!$empty($cookies.get('kakaoLogin'))" @click="logout1"> -->
      </div>
    </div>
    <keep-alive v-if="$route.meta.keepAlive">
      <router-view class="router-view-main"
                   :style="{marginTop: $store.state.kakao ? '0px' : '50px'}" />
    </keep-alive>
    <router-view v-else />
    <div class="footer"
         v-if="$route.path !== '/productBasket' && $route.path !== '/sery' && !$store.state.kakao">
      <carousel :slides="slides"
                :autoplay="true"
                :interval="5000" />
    </div>
    <!-- <div class="footer" v-if="$route.path !== '/productBasket'" @click="moveAdfit">
      <ins class="kakao_ad_area" style="display:none;"
        data-ad-unit = "DAN-VYuzPzC5U0GAMvNu"
        data-ad-width = "320"
        data-ad-height = "50"></ins>
    </div> -->
    <modal name="mobileSelect"
           :styles="'background:rgba(255, 255, 255, 0);box-shadow:none;'"
           :width="300"
           :height="300"
           :clickToClose="false">
      <div class="modalMain">
        <div class="modalMain-1">
          <div class="modalMain-1-left">
            <img src="@/assets/icon/tery-symbol.png"
                 style="width:83px;height:auto;object-fit:contain;margin:auto;">
          </div>
          <div class="modalMain-1-right">
            <span class="introWord">테리 앱으로</span><br>
            <span class="introWord">더 편리하게</span><br>
            <span class="introWord">주문하세요!</span><br>
          </div>
        </div>
        <div class="modalMain-2">
          <button class="down-app"
                  @click="goGooglePlay">
            테리앱 다운로드
          </button>
        </div>
        <div class="modalMain-2"
             style="height: 50px;padding-top:20px;">
          <img src="@/assets/search-clear.png"
               style="width: 15px;height: 15px;object-fit: contain;"
               @click="$modal.hide('mobileSelect')">&nbsp;
          <span class="introWord"
                style="font-size:18px;"
                @click="$modal.hide('mobileSelect')">괜찮아요. 모바일로 볼께요.</span>
        </div>
      </div>
    </modal>
    <modal name="certify"
           :width="'99%'"
           :height="520"
           :clickToClose="false">
      <div class="certifyMain"
           style="position:relative;border: 1px solid rgba(234, 78, 131, 0.5);">
        <span class="closeBtn"
              @click="$modal.hide('certify')">×</span>
        <div class="certifyHead">
          <h3>테리 약관 동의</h3>
          <hr style="color:#e0e0e0;">
        </div>
        <div class="certifyBody">
          <div class="certifyBody-inner">
            <span style="color:#ea4e83;">**</span>
            <span>&emsp;최초 1회 인증이 필요합니다.</span>
          </div>
          <div class="certifyBody-inner">
            <input type="checkbox"
                   name="agree1"
                   id="agree1"
                   v-model="$store.state.agrees.agree1">
            <label for="agree1"
                   style="margin-left: 10px;">회원이용 약관</label>
          </div>
          <div class="certifyBody-inner">
            <input type="checkbox"
                   name="agree2"
                   id="agree2"
                   v-model="$store.state.agrees.agree2">
            <label for="agree2"
                   style="margin-left: 10px;">개인정보 수집 및 처리방침</label>
          </div>
          <div class="certifyBody-inner">
            <input type="checkbox"
                   name="agree3"
                   id="agree3"
                   v-model="$store.state.agrees.agree3">
            <label for="agree3"
                   style="margin-left: 10px;">위치정보 이용약관</label>
          </div>
          <div class="certifyBody-inner"
               style="justify-content: space-between;">
            <span>전화번호: </span>
            <input type="tel"
                   name="phone"
                   id="phone"
                   v-model="$store.state.userPhone"
                   class="certify-phone-input"
                   placeholder="휴대전화번호"
                   v-if="chkConfirm !== 1">
            <input type="tel"
                   name="phone"
                   id="phone"
                   v-model="$store.state.userPhone"
                   class="certify-phone-input-readonly"
                   placeholder="휴대전화번호"
                   readonly
                   v-if="chkConfirm === 1">
            <button class="certify-phone-btn"
                    @click="getConfirmNo"
                    v-if="chkConfirm === 0">인증번호받기</button>
            <button class="certify-phone-btn-readonly"
                    v-if="chkConfirm === 1">인증번호받기</button>
          </div>
          <div class="certifyBody-inner"
               style="justify-content: space-between;"
               v-if="chkConfirm === 1">
            <span>인증번호: </span>
            <input type="number"
                   v-model="confirmNumber"
                   class="certify-phone-input"
                   placeholder="인증번호 입력">
            <button class="certify-phone-btn"
                    @click="chkConfirmNo"
                    v-if="chkConfirm === 1">인증번호확인</button>
          </div>
        </div>
        <div class="certifyFoot-on"
             @click="completeCertify">
          <span>확인</span>
        </div>
      </div>
    </modal>
    <modal name="easySearchAddr"
           :width="'99%'"
           :height="520"
           :click-to-close="false">
      <div class="addrModalMain">
        <div style="width:100%;height:5%;margin:auto;background: #ffffff;text-align:right;display:relative;">
          <span @click="$modal.hide('easySearchAddr')"
                class="searchModalclose">×</span>
        </div>
        <div style="width:100%;height:95%;margin:auto;background: #ffffff;">
          <vue-daum-postcode style="width:100%;height:100%;background: #ffffff;"
                             :theme="{
                                bgColor: '#ffffff',
                                searchBgColor: '#ffffff',
                                contentBgColor: '#ffffff',
                                pageBgColor: '#ffffff',
                                textColor: '#000000',
                                queryTextColor: '#000000',
                                outlineColor: 'red'
                              }"
                             @complete="easySetAddr($event)" />
        </div>
      </div>
    </modal>
    <!-- <modal name="searchAddr" :width="'99%'" :height="520" :click-to-close="false">
      <div class="addrModalMain">
        <div style="width:100%;height:5%;margin:auto;background: #ffffff;text-align:right;display:relative;">
          <span @click="$modal.hide('searchAddr')" class="searchModalclose">×</span>
        </div>
        <div style="width:100%;height:95%;margin:auto;background: #ffffff;" v-if="$store.state.detailAddrFlag === 0">
          <vue-daum-postcode style="width:100%;height:100%;background: #ffffff;"
                            :theme="{
                                bgColor: '#ffffff',
                                searchBgColor: '#ffffff',
                                contentBgColor: '#ffffff',
                                pageBgColor: '#ffffff',
                                textColor: '#000000',
                                queryTextColor: '#000000',
                                outlineColor: 'red'
                              }" @complete="setAddr($event)" />
        </div>
        <div v-else style="position:relative;text-align:left;width:100%; height:95%; box-sizing: border-box; padding: 5px;">
          <div>
            <h2 style="margin:0;">
              상세주소입력
            </h2>
            <hr>
          </div>
          <div class="addrDiv">
            <div style="flex:2;" class="addrDiv-inner">
              <span style="color:#ea4e83;">*</span>
              <span>&emsp;주소</span>
            </div>
            <div style="flex: 5;" class="addrDiv-inner">
              <input type="text" class="inputDetailAddr" v-model="$store.state.addr1" readonly>
            </div>
          </div>
          <div class="addrDiv">
            <div style="flex: 2;" class="addrDiv-inner">
              <span style="color:#ea4e83;">*</span>
              <span>&emsp;상세주소</span>
            </div>
            <div style="flex: 5;" class="addrDiv-inner">
              <input type="text" class="inputDetailAddr" v-model="$store.state.addr2" placeholder="상세주소를 입력해 주세요.">
            </div>
          </div>
          <div class="addrDiv">
            <div style="flex:2;" class="addrDiv-inner">
              <span style="color:#ea4e83;">*</span>
              <span>&emsp;받는분</span>
            </div>
            <div style="flex: 5;" class="addrDiv-inner">
              <input type="text" class="inputDetailAddr" v-model="$store.state.customerName" placeholder="받는분 성함을 입력해 주세요.">
            </div>
          </div>
          <div class="addrDiv">
            <div style="flex:2;" class="addrDiv-inner">
              <span style="color:#ea4e83;">*</span>
              <span>&emsp;전화번호</span>
            </div>
            <div style="flex: 5;" class="addrDiv-inner">
              <input type="text" class="inputDetailAddr" v-model="$store.state.customerPhone" placeholder="전화번호를 입력해 주세요.">
            </div>
          </div>
          <div class="confirmAddr-off" :class="$store.state.addr2 !== '' ? 'confirmAddr-on' : 'confirmAddr-off'" @click="chkInputInfo">
            <span>확인</span>
          </div>
        </div>
      </div>
    </modal> -->
    <modal name="orderDetail"
           :width="'99%'"
           :height="'90%'">
      <div class="orderDetailMain">
        <div class="orderDetailHead">
          <div class="orderDetailHead-title">
            <span class="closeBtn"
                  style="right:0px;"
                  @click="$modal.hide('orderDetail')">×</span>
            <h2 style="margin:10px 0px;font-weight:500;">
              주문상세내역
            </h2>
          </div>
          <hr style="width:100%;border-top: 1px solid rgba(0, 0, 0, 0.2);">
          <div class="orderDetailHead-info">
            <div class="orderDetailHead-inner">
              <span style="font-size: 13px;color:#a0a0a0;">
                성함
              </span>
              <span v-if="!$empty($store.state.orderDetail)">
                {{`${$store.state.orderDetail.deliveryInfo.receiveName}`}}
              </span>
            </div>
            <div class="orderDetailHead-inner">
              <span style="font-size: 13px;color:#a0a0a0;">
                전화번호
              </span>
              <span v-if="!$empty($store.state.orderDetail)">
                {{`${$store.state.orderDetail.deliveryInfo.receivePhone1}`}}
              </span>
            </div>
            <div class="orderDetailHead-inner">
              <span style="font-size: 13px;color:#a0a0a0;">
                주소
              </span>
              <span v-if="!$empty($store.state.orderDetail)">
                {{`${$store.state.orderDetail.deliveryInfo.receiveAddress} ${$store.state.orderDetail.deliveryInfo.receiveAddressDetail}`}}
              </span>
            </div>
          </div>
          <!-- <div class="orderDetailHead-inner">
            <span style="font-size: 13px;color:#a0a0a0;">
              요청사항
            </span>
            <span v-if="!$empty($store.state.orderDetail)">
              {{`${$store.state.orderDetail.deliveryInfo.receiveAddress} ${$store.state.orderDetail.deliveryInfo.receiveAddressDetail}`}}
            </span>
          </div> -->
          <br>
          <br>
        </div>
        <div class="orderDetailBody">
          <div class="orderDetailProduct"
               v-for="(row, index) in $store.state.orderDetail.data"
               :key="index">
            <div class="orderDetailProduct-left">
              <div class="orderDetailProduct-badge"
                   v-if="!$empty(row.eventInfo.badgeInfoItem)">
                <img :src="`${row.eventInfo.badgeInfoItem.imageUrl}`"
                     style="width: 30%; max-width: 100px;"
                     v-if="!$empty(row.eventInfo.badgeInfoItem.imageUrl)">
              </div>
              <div class="orderDetailProduct-badge"
                   v-else-if="!$empty(row.eventInfo.badgeInfo) || (!$empty(row.eventInfo.badgeList) && row.eventInfo.badgeList.length > 0)">
                <!-- <img :src="`${row.eventInfo.badgeInfo.imageUrl}`" style="width: 30%; max-width: 100px;" v-if="!$empty(row.eventInfo.badgeInfo.imageUrl)"> -->
                <img :src="`${row.eventInfo.badgeInfo.imageUrl}`"
                     v-if="!$empty(row.eventInfo.badgeInfo) && !$empty(row.eventInfo.badgeInfo.imageUrl) && ($empty(row.eventInfo.badgeList) || row.eventInfo.badgeList.length === 0)"
                     class="badge-image"
                     alt="">
                <img v-if="!$empty(row.eventInfo.badgeList) && row.eventInfo.badgeList.length > 0"
                     :src="row.eventInfo.badgeList[0].imageUrl"
                     class="badge-image"
                     alt="" />
                <img v-if="!$empty(row.eventInfo.badgeList) && row.eventInfo.badgeList.length > 1"
                     :src="row.eventInfo.badgeList[1].imageUrl"
                     class="badge-image badge-image--1"
                     alt="" />
                <img v-if="!$empty(row.eventInfo.badgeList) && row.eventInfo.badgeList.length > 2"
                     :src="row.eventInfo.badgeList[2].imageUrl"
                     class="badge-image badge-image--2"
                     alt="" />
              </div>
              <img :src="row.eventInfo.imageUrl"
                   class="productImg"
                   v-if="!$empty(row.eventInfo.imageUrl)"
                   @error="errorImage">
              <img src="@/assets/no_item_image.png"
                   class="productImg"
                   v-else>
            </div>
            <div class="orderDetailProduct-right">
              <div class="orderDetailProduct-info">
                <span
                      v-if="!$empty(row.eventInfo) && !$empty(row.eventInfo.name) && row.eventInfo.name.length <= 10">{{row.eventInfo.name}}</span>
                <marquee-text :duration="5"
                              v-else>{{row.eventInfo.name}}&emsp;</marquee-text>
              </div>
              <div class="orderDetailProduct-info">
                <span class="orderDetailProduct-price">
                  {{numberWithCommas(row.eventInfo.sellPrice)}}
                </span>
              </div>
              <div class="orderDetailProduct-info">
                {{row.orderQty + '개'}}
              </div>
            </div>
            <!-- <hr style="border: 1px solid #ececec;margin:0;">
            <div style="width:100%;auto;text-align:right;box-sizing: border-box;">
              <span>상품문의</span>
              <span>상품댓글</span>
              <span>취소</span>
            </div> -->
          </div>
        </div>
        <div class="orderDetailFoot">
          <span class="orderDetailProduct-total">{{sumTotal()}}</span>
          <span style="font-size: 10px;"
                v-if="!$empty($store.state.orderDetail.deliveryPrice) && $store.state.orderDetail.deliveryPrice > 0">(*
            배달료포함)</span>
        </div>
      </div>
    </modal>
    <!-- <modal name="onlyOffline" :width="'99%'" :height="'50%'" :clickToClose="false">
      <div class="onlyOffline-main">
        <div class="onlyOffline-body">
          <img src="@/assets/tery_fail1.png" class="onlyOffline-img" alt="">
          <span>
            해당 매장은 오프라인 전용 매장으로<br>온라인 구매를 할 수 없습니다.<br>자세한 문의는 매장으로 부탁드립니다.
          </span>
        </div>
        <div class="onlyOffline-foot">
          <div class="onliOffline-close">
            <img src="@/assets/icon_whitephone.png" class="onlyOffline-phone-img" alt="">
            <a :href="`tel:${$store.state.storeInfo.STORE_TEL}`">
              <span class="onlyOffline-close-btn" style="color:#ffffff;">
                전화하기
              </span>
            </a>
          </div>
          <div class="onlyOffline-phone" @click="$modal.hide('onlyOffline')">
            <span class="onlyOffline-close-btn">창닫기</span>
          </div>
        </div>
      </div>
    </modal> -->
    <modal name="postBasket"
           :width="'99%'"
           :height="200">
      <div class="inBasketMain">
        <div class="inBasketTitle">
          <h2 style="margin:0;">장바구니</h2>
        </div>
        <div class="inBasketContent">
          <span>
            장바구니에 추가되었습니다.
          </span>
        </div>
        <div class="inBasketContent"
             style="margin-bottom:20px;">
          <span>
            보관함으로 이동하시겠습니까?
          </span>
        </div>
        <div class="inBasketFoot">
          <span class="inBasketBtn"
                @click="$modal.hide('postBasket')">나중에</span>
          &emsp;
          <span class="inBasketBtn"
                @click="[moveRouter('productBasket'), $cookies.set('nowPage', 'productBasket')]">확인</span>
        </div>
      </div>
    </modal>
    <div :class="[$store.state.inBasket ? 'inBasket-on' : 'inBasket-off']">
      <div class="basket-left">
        <img src="@/assets/icon/tery.png"
             class="tery-shadow">
      </div>
      <div class="basket-right">
        <div class="right-top">
          <span class="inBasket-span1">잘 담아</span>
        </div>
        <div class="right-bottom">
          <span class="inBasket-span2">놓았습니다.</span>
        </div>
      </div>
    </div>
    <div :class="[$store.state.isLoading ? 'loadingDiv-on' : 'loadingDiv-off']">
      <span class="closeBtn-loading"
            @click="hideLoading">×</span>
      <img src="@/assets/logo/tery2.svg"
           class="loadingLogo"
           v-if="$store.state.isLoading"
           style=""
           alt="">
      <loading :active.sync="$store.state.isLoading"
               :can-cancel="false"
               :loader="'dots'"
               :background-color="'#ffffff'"
               :color="'#000000'"
               :opacity="1"
               :lock-scroll="true"
               :blur="'50px'"></loading>
      <h2 class="loadingWord"
          v-if="$store.state.isLoading">잠시만 기다려 주세요</h2>
    </div>
  </div>
</template>

<script>
import { VueDaumPostcode } from 'vue-daum-postcode';
import { loginWithKakao, logout } from '@/components/publicFunc/public';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { defualtMeta } from '@/js/meta';
import Carousel from '@/components/shareComponent/Carousel.vue';

export default {
  name: 'App',
  metaInfo: {
    meta: defualtMeta,
  },
  components: {
    VueDaumPostcode,
    Loading,
    Carousel,
  },
  computed: {
    appFlag: function () {
      return this.$store.state.storeInfo.APP_FLAG;
    },
    appIcon: function () {
      return this.$store.state.storeInfo.STORE_ICON;
    },
    appUrl: function () {
      return this.$store.state.storeInfo.APP_URL;
    },
  },
  data() {
    return {
      chkConfirm: 0,
      // nowDevice: '',
      confirmNumber: '',
      fullPage: false,
      basketProductCount: 0,
      key: '',
      slides: [
        {
          id: 'tery-messenger',
          image: require('@/assets/banner/220717teryMessenger002_img.png'),
          imageStyle: 'width: 100%; height: 50px; object-fit: contain',
          background: '#ff9ed0',
          clickHandler: this.moveTerysmsInstall,
          alt: '테리 메신저',
        },
        {
          id: 'sery',
          image: require('@/assets/logo/ci-sery.png'),
          imageStyle: 'object-fit: contain; width: 24px; height: 40px;',
          background: '#ff9ed0',
          description: '세리에서 발송 되었습니다.',
          clickHandler: this.moveSeryTutorial,
          alt: '세리',
        },
      ],
    };
  },
  async mounted() {
    const vm = this;
    const result = await this.getHandyVersionCheck();
    console.log('mounted :::::', this.$options.name);
    if (result.data.needRefresh === 1 && result.data.version !== process.env.version) {
      vm.$store.commit('setIsLoading', false);
      vm.$router.push({ path: '/version-check', query: vm.$route.query });
      return;
    }
    // vm.$modal.show('mobileSelect')
    // if (!vm.$empty(vm.$cookies.get('storeInfo'))) {
    //   vm.$store.state.storeInfo = vm.$_.cloneDeep(vm.$cookies.get('storeInfo'))
    // }
    vm.$modal.show('processLogin');
    // 최초로딩 시 매장정보 가져오기
    if (vm.$cookies.get('storeSeq') === undefined) {
      vm.$cookies.remove('storeSeq');
    }
    // 사용자 정보 확인
    if (!vm.$empty(vm.$route.query.userSeq) && !vm.$empty(vm.$route.query.userPhone)) {
      this.$cookies.set('userSeq', vm.$route.query.userSeq);
    }

    // 디바이스체크
    vm.chkDevice();
    if (vm.$empty(vm.$cookies.get('kakaoLogin'))) {
      vm.$cookies.remove('userData');
      vm.$store.state.userData = {};
    } else {
      vm.$store.state.userData = vm.$_.cloneDeep(vm.$cookies.get('userData'));
    }
    if (vm.$route.path !== '/' && vm.$route.path !== '/searchMain') {
      // key
      vm.key = vm.$route.query.seq;
      !vm.$empty(vm.$route.query.eventSeq) && (await vm.setKey(vm.$route.query.eventSeq));
      vm.$store.commit('setKey', vm.key);
      vm.$store.state.storeSeq = vm.$_.cloneDeep(vm.$route.query.seq);
      if (
        vm.$empty(vm.$store.state.storeDeliveryInfo) ||
        vm.$empty(vm.$store.state.storeDeliveryInfo.DELIVERY_START_TIME) ||
        vm.$empty(vm.$store.state.storeDeliveryInfo.DELIVERY_END_TIME)
      ) {
        await vm.getStoreDeliveryInfo(vm.$route.query.seq);
      }
      // await vm.setMyUserSeq()
    }
    if (vm.$route.path === '/chat' && !vm.$empty(vm.$route.query.seq)) {
      vm.pushPage('chat');
    } else if (vm.$route.path === '/productBasket' && !vm.$empty(vm.$route.query.seq)) {
      vm.pushPage('productBasket');
    } else if (vm.$route.path === '/paymentCard' && !vm.$empty(vm.$route.query.seq)) {
      vm.pushPage('paymentCard');
    } else if (vm.$route.path === '/orderProcessList' && !vm.$empty(vm.$route.query.seq)) {
      vm.pushPage('orderProcessList');
    } else if (vm.$route.path === '/booking' && !vm.$empty(vm.$route.query.seq)) {
      vm.pushPage('booking');
    } else if (vm.$route.path === '/wishList' && !vm.$empty(vm.$route.query.seq)) {
      vm.pushPage('wishList');
    } else if (vm.$route.path === '/sery') {
      vm.pushPage('sery');
    } else if (!vm.$empty(vm.$route.query.detail) && !vm.$empty(vm.$route.query.seq)) {
      vm.pushPage('detailProduct');
    } else if (!vm.$empty(vm.$route.query.eventSeq) && !vm.$empty(vm.$route.query.seq)) {
      vm.$store.commit('setEventSeq', vm.$route.query.eventSeq);
      vm.$cookies.set('mobileSelect', vm.$store.state.device);
      vm.pushPage('storeMain');
    } else if (!vm.$empty(vm.$route.query.seq)) {
      vm.$cookies.set('mobileSelect', vm.$store.state.device);
      vm.pushPage('storeMain');
    } else {
      if (vm.$empty(vm.$router.history.current.name)) {
        vm.$router.push('/searchMain');
      } else {
        vm.pushPage(vm.$router.history.current.name);
      }
    }
  },
  beforeDestroy() {},
  methods: {
    // moveTelAd () {
    //   this.$gtag.event('광고_배너_하단_선택', {
    //     'event_category': this.$route.query.seq,
    //     'event_label': '광고_배너',
    //     'value': this.$cookies.get('userSeq')
    //   })
    //   window.open('tel:01085009548')
    // },
    // moveAdfit () {
    //   this.$gtag.event('카카오광고_배너_하단_선택', {
    //     'event_category': this.$route.query.seq,
    //     'event_label': '카카오광고_배너',
    //     'value': this.$cookies.get('userSeq')
    //   })
    // },
    handleBackPage() {
      // if (this.$route.path === )
      console.log('handleBackPage :::::');
      const vm = this;
      if (vm.$route.path === '/detailProduct') {
        const { seq, eventSeq } = vm.$route.query;
        if (!vm.$empty(vm.$route.query.eventSeq)) {
          vm.$store.commit('setEventSeq', eventSeq);
          vm.$router.replace({ name: 'storeMain', query: { seq: seq, eventSeq: eventSeq } });
          vm.checkSeqQuery();
        } else {
          vm.moveRouter('storeMain');
        }
        // } else if (vm.$route.path === '/orderProcessList' || vm.$route.path === '/chat') {
        //   vm.moveRouter('storeMain')
        // } else {
        //   vm.$router.go(-1)
      } else {
        vm.$router.go(-1);
      }
    },
    loginWithKakao1() {
      this.$store.state.isLoading = true;
      loginWithKakao();
    },
    logout1() {
      this.$store.state.isLoading = true;
      logout();
    },
    hideLoading() {
      this.$store.state.isLoading = false;
    },
    pushPage(name) {
      console.log('pushPage :::::', name);
      if (name === 'orderProcessList') {
        if (!this.$empty(this.$cookies.get('kakaoLogin'))) {
          this.$cookies.set('nowPage', name);
          this.$router.push(name).catch(() => {});
        } else {
          this.$store.state.isLoading = true;
          // this.loginWithKakao1()
          this.$router.push(name).catch(() => {});
        }
      } else if (name === 'storeMain') {
        this.$cookies.set('nowPage', name);
        this.$router.push(name).catch(() => {});
      }
    },
    chkDevice() {
      console.log('chkDevice :::::');
      var device = navigator.userAgent.toLowerCase();
      var result = '';
      if (device.match('iphone') || device.match('ipad') || device.match('ipod')) {
        // 아이폰
        result = 'ios';
        // this.nowDevice = result
        this.$cookies.set('device', result);
      } else if (device.match('android')) {
        // 안드로이드 기기
        result = 'android';
        // this.nowDevice = result
        this.$cookies.set('device', result);
      } else {
        // 그 외
        result = 'pc';
        // this.nowDevice = result
        this.$cookies.set('device', result);
      }
      this.$store.state.device = result;
    },
    goGooglePlay() {
      window.location.href = `https://play.google.com/store/apps/details?id=com.tonovation.tery&hl=ko&gl=US`;
    },
    setKey(eventSeq) {
      const vm = this;
      return new Promise((resolve, reject) => {
        vm.key = `${vm.$route.query.seq}_${eventSeq}`;
        resolve('success');
      });
    },
    easySetAddr(value) {
      console.log('eventSetAddr :::::', value);
      if (!this.$empty(value.buildingName)) {
        this.$store.state.addr1 = value.address + ' (' + value.buildingName + ')';
      } else {
        this.$store.state.addr1 = value.address;
      }
      this.$modal.hide('easySearchAddr');
    },
    setAddr(value) {
      console.log('setAddr :::::', value);
      if (!this.$empty(value.buildingName)) {
        this.$store.state.addr1 = value.address + ' (' + value.buildingName + ')';
      } else {
        this.$store.state.addr1 = value.address;
      }
      this.$store.state.detailAddrFlag = 1;
    },
    getAddress() {
      console.log('getAddress :::::');
      var userData = this.$cookies.get('userData');
      if (!this.$empty(userData)) {
        this.$axios({
          method: 'get',
          url: `${process.env.API}/getAddress/id/${userData.USER_SEQ}`,
        }).then((response) => {
          if (response.data !== 'empty') {
            this.$store.state.addressList = this.$_.cloneDeep(response.data);
          }
        });
      } else {
        console.log('최초가입');
      }
    },
    getConfirmNo() {
      console.log('getConfirmNo :::::');
      var regExp = /^01([0|1|6|7|8|9]?)-?([0-9]{3,4})-?([0-9]{4})$/;
      if (this.$store.state.agrees.agree1 && this.$store.state.agrees.agree2 && this.$store.state.agrees.agree3) {
        if (!regExp.test(this.$store.state.userPhone)) {
          alert('전화번호를 확인해 주세요.');
        } else {
          // var userPhone = this.$store.state.userPhone
          // userPhone = JSON.stringify(userPhone)
          this.$axios({
            method: 'post',
            url: `https://sery.co.kr/insertConfirmNo`,
            data: {
              userPhone: this.$store.state.userPhone,
            },
          }).then((response) => {
            if (response.data.result === 'success') {
              this.chkConfirm = 1;
              alert('발급된 숫자 5자리를 입력해 주세요.\n발급까지 (2~3분 정도 걸릴수 있습니다.)');
            }
          });
        }
      } else {
        alert('모든약관에 동의하셔야 사용이 가능합니다.');
      }
    },
    chkConfirmNo() {
      console.log('chkConfirmNo :::::');
      if (this.$empty(this.confirmNumber) || this.confirmNumber.length < 5) {
        alert('인증번호를 다시 입력해 주세요');
      } else {
        this.$axios({
          method: 'post',
          url: `https://sery.co.kr/phoneConfirmNo`,
          data: {
            userPhone: this.$store.state.userPhone,
            confirmNo: this.confirmNumber,
          },
        }).then((response) => {
          if (response.data.result === 'success') {
            this.chkConfirm = 2;
            if (!this.$empty(response.data.userSeq)) {
              this.$store.state.userData = response.data;
              this.insertKakaoAuth();
            } else {
              alert('제조자에 문의 바랍니다.');
            }
          } else {
            alert('인증번호를 확인해 주세요.');
          }
        });
      }
    },
    insertKakaoAuth() {
      console.log('insertKakaoAuth :::::');
      var cookies = this.$cookies.get('kakaoLogin');
      if (!this.$empty(cookies) && !this.$empty(this.$store.state.userPhone)) {
        this.$axios({
          method: 'post',
          url: `${process.env.API}/insertAuth`,
          data: {
            auth: this.$empty(cookies) ? '' : cookies.id,
            phone: this.$store.state.userPhone,
          },
        }).then((response) => {
          alert('인증이 완료되었습니다.!');
          this.getTeryInfo(cookies.id);
        });
      }
    },
    getTeryInfo(key) {
      console.log('getTeryInfo :::::');
      this.$axios({
        method: 'get',
        url: `${process.env.API}/getTeryInfo/key/${key}`,
      }).then((response) => {
        if (!this.$empty(response)) {
          this.$store.state.userData = response.data[0];
          var userData = JSON.stringify(response.data[0]);
          this.$cookies.set('userData', userData, '30MIN');
          this.$cookies.set('userSeq', userData.USER_SEQ);
        } else {
          console.log('getTeryInfo err :::::');
        }
      });
    },
    chkInputInfo() {
      console.log('chkInputInfo :::::');
      if (this.$empty(this.$store.state.addr2) || this.$empty(this.$store.state.customerName) || this.$empty(this.$store.state.customerPhone)) {
        alert('데이터 확인');
      } else {
        if (this.$store.state.updateAddrFlag === 0) {
          var cookies = this.$cookies.get('kakaoLogin');
          var user = this.$store.state.userData;
          var obj = {
            name: this.$store.state.customerName,
            addr1: this.$store.state.addr1,
            addr2: this.$store.state.addr2,
            phone: this.$store.state.customerPhone,
            kakaoId: this.$empty(cookies) ? '' : cookies.id,
            userSeq: user.USER_SEQ,
          };
          this.$axios({
            method: 'post',
            url: `${process.env.API}/regCustomer`,
            data: obj,
          }).then((reponse) => {
            if (reponse.data === 'success') {
              this.$store.state.customerName = '';
              this.$store.state.addr1 = '';
              this.$store.state.addr2 = '';
              this.$store.state.customerPhone = '';
              this.$store.state.detailAddrFlag = 0;
              this.getAddress();
              alert('등록되었습니다.');
              this.$modal.hide('searchAddr');
            } else {
              console.log('insert new addr err:::');
            }
          });
        } else {
          var updateObj = {
            name: this.$store.state.customerName,
            addr1: this.$store.state.addr1,
            addr2: this.$store.state.addr2,
            phone: this.$store.state.customerPhone,
            deliverySeq: this.$store.state.preUpdateAddr.DELIVERY_SEQ,
          };
          this.$axios({
            method: 'patch',
            url: `${process.env.API}/updateAddr`,
            data: updateObj,
          }).then((response) => {
            if (response.data === 'success') {
              this.$store.state.customerName = '';
              this.$store.state.addr1 = '';
              this.$store.state.addr2 = '';
              this.$store.state.customerPhone = '';
              this.$store.state.detailAddrFlag = 0;
              this.$store.commit('resetUpdateAddrData');
              this.getAddress();
              alert('수정되었습니다.');
              this.$modal.hide('searchAddr');
            } else {
              console.log('update addr err:::');
            }
          });
        }
      }
    },
    completeCertify() {
      this.$modal.hide('certify');
      this.$modal.show('searchAddr');
    },
    sumTotal() {
      console.log('sumTotal :::::');
      if (!this.$empty(this.$store.state.orderDetail) && !this.$empty(this.$store.state.orderDetail.data)) {
        var result = this.$store.state.orderDetail.deliveryPrice;
        for (let i = 0; i < this.$store.state.orderDetail.data.length; i++) {
          var data = this.$store.state.orderDetail.data[i];
          result += Number(data.eventInfo.sellPrice) * Number(data.orderQty);
        }
        return this.numberWithCommas(result);
      } else {
        return 0;
      }
    },
    // async setMyUserSeq () {
    //   const vm = this
    //   const getMyUserSeq = localStorage.getItem(`${vm.$route.query.seq}_userSeq`)
    //   const getMyUserIndex = localStorage.getItem(`${vm.$route.query.seq}_userIndex`)
    //   if (!vm.$empty(getMyUserSeq) && getMyUserSeq !== 'undefined' && !vm.$empty(getMyUserIndex) && getMyUserIndex !== 'undefined') {
    //     return
    //   }
    //   const data = {
    //     storeSeq: vm.$route.query.seq,
    //     sK: 'ROOM#LIVE',
    //     userIndex: 1
    //   }
    //   await API.graphql({
    //     query: mutations.updateStoreQnaInfoTable,
    //     variables: { input: data }
    //   }).then((response) => {
    //     console.log('userIndex 생성 => ', response.data)
    //     vm.userIndex = response.data.updateStoreQnaInfoTable.userIndex
    //   })
    //   const timeStamp = Date.now()
    //   const random = Math.ceil(Math.random() * 100000)
    //   const myUserSeq = String(timeStamp) + String(random)
    //   if (vm.$empty(getMyUserSeq) || getMyUserSeq === 'undefined') {
    //     localStorage.setItem(`${vm.$route.query.seq}_userSeq`, myUserSeq)
    //   }
    //   if (vm.$empty(getMyUserIndex) || getMyUserIndex === 'undefined') {
    //     console.log('userIndex :::::', vm.userIndex)
    //     localStorage.setItem(`${vm.$route.query.seq}_userIndex`, vm.userIndex)
    //   }
    // },
    numberWithCommas(x) {
      if (!x) {
        return '0원';
      } else if (x === 0 || x === '0') {
        return '';
      } else {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '원';
      }
    },
    numberWithComma1(x) {
      if (!x) {
        return '0';
      } else if (x === 0 || x === '0') {
        return '';
      } else {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
    },
    // async firstFunc () { // 매장정보 가져오기 (매장사진등)
    //   const vm = this
    //   await this.$axios({
    //     method: 'get',
    //     url: `${process.env.API}/getStoreInfo/store/${vm.$route.query.seq}`
    //   })
    //     .then((response) => {
    //       vm.storeInfo = vm.$_.cloneDeep(response.data[0])
    //       vm.$store.state.storeInfo = vm.$_.cloneDeep(response.data[0])
    //       vm.$cookies.set('storeInfo', vm.$store.state.storeInfo)
    //       if (response.data[0].STORE_LOGO.indexOf(',') !== -1) {
    //         if (response.data[0].STORE_LOGO.indexOf('sery-images') !== -1) {
    //           var url = response.data[0].STORE_LOGO.split(',')
    //           vm.storeImage = `${process.env.imgUrl}/store/${url[1]}`
    //         } else {
    //           // vm.transStoreLogo(response.data[0].STORE_LOGO)
    //         }
    //       } else {
    //         vm.storeImage = response.data[0].STORE_LOGO
    //       }
    //     })
    // }
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;300;400;500;700;900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');
@import url('/app.css');
#app {
  font-family: 'Noto Sans KR', sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/App.vue